import axios from "axios";

const instance = axios.create({
    baseURL: process.env.MIX_INTRANET_API_URL,
    withCredentials: true,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + process.env.MIX_INTRANET_API_TOKEN,
    },
});

export const getData = (endpoint, params) =>
    instance.get(`/database/${endpoint}`, { params });
export const addData = (endpoint, data) =>
    instance.post(`/database/${endpoint}`, data);
export const getCategoriesData = (endpoint) =>
    instance.get(`/database/${endpoint}-categories`);
export const getServicesData = (endpoint) =>
    instance.get(`/database/${endpoint}-services`);
export const exportData = (endpoint, params, responseType) =>
    instance.get(`/database/${endpoint}-export`, { params, responseType });
export const sendToEmail = (endpoint, params) =>
    instance.get(`/database/${endpoint}-send`, { params });
export const getLastUpdate = (params) =>
    instance.get("/database/last-update", { params });
export const upload = (data) => instance.post(`/database/upload`, data);

export const getMunicipalitiesData = () => instance.get("/map/municipalities");
export const getVillagesData = () => instance.get("/map/villages");
export const getStreetsData = () => instance.get("/streets");
export const getSeasonsData = () => instance.get("/seasons");
export const getCuisinesData = () => instance.get("/cuisines");
export const getWinesData = () => instance.get("/wines");
export const getCountriesData = () => instance.get("/countries");
export const getAssociationsData = () => instance.get("/associations");
